<template>
    <div id="campanha-cadastro">
        <section id="content">
            <!--start container-->
            <div class="container">
                <div class="row">
                    <div class="col s12 m12 l12">
                        <div class="card-panel">
                            <h4 class="header">Cadastro de campanha</h4>
                            <div class="row">
                                <form class="col s12" v-on:submit.prevent="save">
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <input placeholder="Nome" id="campanha_nome" type="text" v-model="campanha_nome">
                                            <label for="campanha_nome" class="active">Nome</label>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="input-field col s12">
                                            <button class="btn btn-default waves-effect waves-light right" type="submit" name="action">
                                                Salvar
                                                <!-- <i class="material-icons right">send</i> -->
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!--end container-->
        </section>
    </div>
</template>
<script>
    import { post } from '@/helpers/api';
    import Message from '@/helpers/message';

    export default {
        components: {
        },
        data: () => ({
            campanha_nome: '',
        }),
        methods: {
            save() {
                if (this.campanha_nome === '') {
                    Message.messageError('Todos campos são obrigatórios.');
                    return;
                }

                let self = this;
                post('campanha/', {
                    campanha_nome: this.campanha_nome,
                }).then(function (response) {
                    Message.messageSuccess(response.data.statusMessage);
                    self.$router.push('/campanhas', function () {});
                }).catch(function () {
                    Message.messageError('Ocorreu algum erro, tente novamente mais tarde.');
                });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/campanha/Cadastro.vue